import { handleActions, combineActions } from 'redux-actions'
import * as actions from './actions'

export default handleActions({
  [combineActions(
    actions.fetchGeolocation,
    actions.fetchGeolocationPending,
    actions.fetchGeolocationSuccess,
    actions.fetchGeolocationFailure,
  )]: (state, action) => ({ ...state, status: action.type }),

  [actions.fetchGeolocationSuccess]: (state, action) => ({ ...state, data: action.payload }),
}, {})
